import {
  Component,
  Directive,
  OnInit,
  ViewChild,
  SimpleChanges,
  SimpleChange,
  Pipe,
} from "@angular/core";
import {
  FormControl,
  Validators,
  ValidatorFn,
  NG_VALIDATORS,
  Validator,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { UserService } from "../../services/user.service";
import { User } from "../../data/user";
import { LoaderService } from "../../services/loader.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";
import { SubmitButtonComponent } from "@app/components/common/submit-button.component";
import { ColorEvent } from "ngx-color";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { Listing } from "@app/data/listing";
import { ListingService } from "@app/services/listing.service";
import * as orderSheetUtils from "@js/order-sheet.utils";

import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { Angulartics2 } from "angulartics2";
import { FileService } from "@app/services/file.service";
import { File } from "../../data/file";
import { Catalog } from "@app/data/catalog";
import { CatalogService } from "@app/services/catalog.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./catalog-order-sheet.download.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class CatalogOrderSheetDownloadComponent implements OnInit {
  @ViewChild("addToStoreSupermodal")
  addToStoreSupermodalComponent: SupermodalComponent;

  config: DropzoneConfigInterface = {
    url: "api/v2/files",
    maxFilesize: 2,
    acceptedFiles: "image/*",
  };
  listing: Listing;
  user: User;
  userModel: User;
  preview: string;
  fonts: File[];
  //  fields: [{image: true, title: true, price: true, msrp: true, sku: true, description: true, variants: true, comments: true, unit_price: true, quantity: true}];
  //  fields: [{image: 'Value', title: 'Value', price: 'Value', msrp: 'Value', sku: 'Value', description: 'Value', variants: 'Value', comments: 'Value', unit_price: 'Value', quantity: 'Value'}];

  //  columns: [{ prop: 'image' }, { name: 'Title' }, { name: 'Price' }, { name: 'MSRP' }, { name: 'SKU' }, { name: 'Description' }, { name: 'Variants' }, { name: 'Comments' }, { prop: 'unit_price', name: 'Unit Price' }, { name: 'Quantity' }, { name: 'Total' }];
  fields = [
    {
      image: true,
      title: true,
      price: true,
      msrp: true,
      sku: true,
      description: true,
      variants: true,
      comments: true,
      unit_price: true,
      quantity: true,
    },
  ];
  columns = [
    { prop: "image", name: "" },
    { name: "Title" },
    { name: "Price" },
    { name: "MSRP" },
    { name: "SKU" },
    { name: "Description" },
    { name: "Variants" },
    { name: "Comments" },
    { name: "Unit Price" },
    { name: "Quantity" },
    { name: "Total" },
  ];
  availableProductFields: string[] = [
    "title",
    "price",
    "msrp",
    "sku",
    "description",
    "variants",
  ];
  headerOptions: { value: string; label: string }[] = [
    {
      value: "logo",
      label: "Logo",
    },
    {
      value: "name",
      label: "Name",
    },
    {
      value: "address",
      label: "Address",
    },
    {
      value: "phone_number",
      label: "Phone Number",
    },
    {
      value: "contact_email",
      label: "Contact Email",
    },
    {
      value: "website",
      label: "Website",
    },
  ];
  fontsLoaded: boolean = false;
  presetFonts: string[] = [];
  catalog: Catalog;
  subscription: any;

  constructor(
    private angulartics2: Angulartics2,
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private userService: UserService,
    protected loaderService: LoaderService,
    private fileService: FileService
  ) {}

  ngOnInit(): void {
    this.loaderService.isLoading = true;
    this.userService.me().then((user) => {
      this.setUserModel(user);
    });
    this.angulartics2.eventTrack.next({ action: "Opened Order Sheet Page" });
    this.subscription = this.route.params.subscribe((params) => {
      this.catalogService.getCatalog(params["id"]).then((catalog) => {
        this.catalog = catalog;
        this.refreshPreview();
      });
    });
    this.fileService.get("font").then((fonts) => {
      this.fonts = fonts;
      let fontStyle = "";
      this.fonts.forEach((font) => {
        this.presetFonts.push(font.name);
        fontStyle += `
          @font-face {
            font-family: "${font.name}";
            src: url('${font.url}');
          }
          `;
      });
      $("head").append(`<style type="text/css">${fontStyle}</style>`);
      this.fontsLoaded = true;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private setUserModel(user: User) {
    this.user = user;
    this.userModel = JSON.parse(JSON.stringify(this.user));
    this.loaderService.isLoading = false;
    this.refreshPreview();
  }
  private submitOrderSheet() {
    this.userService.update(this.userModel).then((user) => {
      this.setUserModel(user);
    });
  }

  private updateCheckedOptions(field, value, event) {
    if (event.target.checked) {
      field.push(value);
    } else {
      field.splice(field.indexOf(value), 1);
    }
    this.refreshPreview();
  }

  // private checkHeaderField(field: string, returnValue: any): any {
  //   return this.userModel.order_sheet_configuration.header_fields.indexOf(field) > -1 ? (returnValue || '') : '';
  // }

  // private checkFooterField(field: string, returnValue: any): any {
  //   return this.userModel.order_sheet_configuration.footer_fields.indexOf(field) > -1 ? (returnValue || '') : '';
  // }

  // private checkProductField(field: string, returnValue: any): any {
  //   return this.userModel.order_sheet_configuration.product_fields.indexOf(field) > -1 ? (returnValue || '') : '';
  // }

  private refreshPreview() {
    if (this.catalog && this.user) {
      this.preview = orderSheetUtils.buildOrderSheet(
        orderSheetUtils.ORDER_SHEET_TEMPLATE,
        this.userModel,
        this.catalog
      );
    }
  }

  colorChanged(field, $event: ColorEvent) {
    this.userModel.tear_sheet[field] = $event.color.hex;
    this.refreshPreview();
  }

  onUploadSuccess($event) {
    this.userModel.business_profile.logo_url = $event[1].url;
    this.refreshPreview();
  }
}
